module.exports = __webpack_public_path__ + "static/img/closeIcon.63764460.svg";